<template>
  <div class="s_submit_content">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead/>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>收支</el-breadcrumb-item>
                <el-breadcrumb-item>开票申请</el-breadcrumb-item>
                <el-breadcrumb-item>提交申请</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_employee_box" v-loading="tableLoading">
            <div class="p_employee_list">
                <div class="r_edit_title"><div class="line_box"></div>基础信息</div>
                <div class="p_employee_form">
                    <div class="p_employee_item">
                        <!-- 项目或部门 -->
                        <p class="emp_txt">开票项目:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userName}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">状态:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userTel}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">项目/部门:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.stridcard}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">申请人:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userNumber}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">电话:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userlabelname}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">创建时间:</p>
                        <div class="emp_form_txt">
                            {{ruleForm.dtEntryDate}}
                        </div>
                    </div>
                </div>
                <!-- 发票开具申请单 -->
                <div class="flex aic print_box">
                    <el-button type="text" @click="printClick('printBox','')">打印</el-button>
                </div>
                <div class="com_form_box">
                    <div id="printBox">
                        <div class="centerTitle">发票开具申请单</div>
                        <table width="100%" border="0" cellspacing="1" cellpadding="4" class="tabtop form_table" align="center">
                        <tr>
                            <td class="btbg font-center">*合伙人</td>
                            <td></td>
                            <td class="btbg font-center">*业务员</td>
                            <td></td>
                            <td class="btbg font-center">*开票申请人</td>
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">*服务部门</td>
                            <td></td>
                            <td class="btbg font-center">*客服</td>
                            <td></td>
                            <td class="btbg font-center">*法务主体</td>
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">*客户名称</td>
                            <td colspan="4"></td>
                            <td colspan="3">纳税人识别号</td>
                        </tr>
                        <tr>
                            <td class="btbg font-center" rowspan="3">*开票内容</td>
                            <td class="btbg font-center">开票方式</td>
                            <td class="btbg font-center">开票项目</td>
                            <td class="btbg font-center">含税金额(元)</td>
                            <td class="btbg font-center">票据种类</td>
                            <td class="btbg" colspan="3">业务类型:业务外包</td>
                        </tr>
                        <tr rowspan="3">
                            <td class="btbg font-center">全额(6%)</td>
                            <td class="btbg font-center">外包服务费</td>
                            <td class="btbg font-center"></td>
                            <td class="btbg font-center">专票</td>
                            <td class="btbg" colspan="3">
                                <p>营业地址:</p>
                                <p>电话:</p>
                                <p>开户行账号:</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">金额合计:</td>
                            <td class="btbg" colspan="3"></td>
                            <td class="btbg" colspan="3">备注</td>
                        </tr>
                        <tr>
                            <td class="btbg" colspan="2">收票地址、联系人及电话(快递信息):</td>
                            <td class="btbg" colspan="6"></td>
                        </tr>
                        <tr>
                            <td class="btbg">申请开票日期:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        <tr>
                            <td class="btbg">合同附件:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        <tr>
                            <td class="btbg">结算的附件:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="p_employee_list">
                <div class="r_edit_title"><div class="line_box"></div>对应结算单</div>
                <div class="dtl_table">
                    <el-table border :data="tableData" style="width:100%">
                        <!-- 项目或部门 -->
                        <el-table-column align="center" label="项目" width="90px">
                            <template slot-scope="{row}">
                                <span>{{row.Strmkname}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="归属月" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strmkname}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结算单编号" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strtype}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结算单金额" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strtoppowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="本次开具金额" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="创建时间" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <p class="d_txt">结算单本次开具发票金额小计： XXXXXX元</p>
                <div class="f_input_box">
                    <p class="f_txt">申请备注:</p>
                    <div class="f_input_right">
                        <el-input v-model="infoForm.StrRemark" type="textarea" rows="4" clearable></el-input>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <el-button @click="backHandle">返回</el-button>
                <el-button type="primary" @click="saveHandle">提交申请开票</el-button>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
import print from 'print-js'
export default {
  name: "updatePost",
  data() {
    return {
        ruleForm: {
            mainuserid: "",
            mainuseridname:'',
            newuserid: "", //用户id
            userTel: "", //手机号
            userName: "", //姓名
            userNumber: "", //编号（新增不用传）
            stridcard: "", //身份证
            strWorkState: "在职", //在离职
            StrIspartner: "否", //是否合伙人
            dtEntryDate: "", //入职时间
            rolelabel: "", //角色标签
            dtQuitDate: "1900-01-01", //离职时间（没有传1900-01-01）
            userlabelid: "", //员工类型id
            userlabelname: "", //员工标签名称
            Strorgancode: "", //部门code
            Strorganname:'',
        },
        infoForm:{
            StrRemark:''
        },
        tableLoading:false,
        isEdit:'dtl',
        // 详情参数
        dtlQuery:{
            mainuserid:'',
            useridr:''
        },
        tableData:[]
    }
  },
  created() {
    this.isEdit = this.$route.query.isEdit
    this.dtlQuery.useridr = this.$route.query.id
    this.dtlQuery.mainuserid = this.$route.query.mainuserid
    // this.getMemberDtl()
  },
  methods: {
    //打印
    printClick(id, ignoreIds) {
    const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
    setTimeout(function () {
        printJS({
        printable: id, // 标签元素id
        type: 'html',
        targetStyles: ['*'],
        style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
        });
    }, 500)
    //各个配置项
    //printable:要打印的id。
    //type:可以是 html 、pdf、 json 等。
    //properties:是打印json时所需要的数据属性。
    //gridHeaderStyle和gridStyle都是打印json时可选的样式。
    //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
    //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
    //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
    //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
    //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
    },
    // 提交申请开票
    saveHandle(){

    },
    // 取消
    backHandle(){
        this.$router.push({
            path: "/invoicing",
        });
    },
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
    }
  }
}
</script>
<style scoped>
.f_input_box{
    display: flex;
    margin-top: 20px;
}
.f_txt{
    width: 80px;
    font-size: 14px;
    color:#555;
}
.f_input_right{
    flex: 1;
}
.print_box{
    justify-content: flex-end;
}
  .centerTitle {
    width: 100%;
    /* margin-bottom: 5px; */
    border: 1px solid #000;
    border-bottom: none;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    box-sizing: border-box;
  }
  .com_form_box{
    margin: 15px 0;
  }
  .tabtop td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }
  .font-center {
    text-align: center
  }
  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
  }
.d_txt{
    font-size: 14px;
    color: #555;
    margin-top: 20px;
}
.btn_box{
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.line_box{
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
}
.dtl_table{
    box-sizing: border-box;
    margin-top: 15px;
}
.emp_txt{
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.r_edit_title{
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color:#000;
    /* border-bottom: 1px solid #DCDFE6; */
}
.emp_form_txt{
    width: 370px;
    font-size: 14px;
    color: #000;
}
.txts01{
    font-size: 14px;
}
.p_employee_item{
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
}
.p_employee_form{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}
.p_employee_box{
    background-color: #fff;
    padding: 15px 10px;
}
</style>
<style>
.s_submit_content .dtl_table .el-table,
.s_submit_content .el-table th.el-table__cell{
  background-color: #E8F7F7; /* 你想要的背景色 */
}
.form_table td{
    border: #000 1px solid;
}
.e_dtl_content .el-table .el-table__cell{
    padding: 4px 0;
}
</style>